import { nagesConfig} from "../../../funciones";
import { indices } from "../../../schemas/sch_indices";

const nConf: nagesConfig = new nagesConfig()

export async function actualizarIndices(indice: indices) {
  console.log("indice:",indice)
  try {
    const response = await fetch(nConf.API_PATH + "/ages/tablas/indices/mensuales/", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(indice)
    });
    const data = await response.json();
  } catch (error) {
    console.error(error);
  }
};
export async function borrarIndices(fecha: Date) {
  console.log("Eliminando ", fecha)
  try {
    const response = await fetch(nConf.API_PATH + "/ages/tablas/indices/mensuales/" + fecha.toString(), {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    });
    console.log("Eliminando ", fecha)
    const data = await response.json();
    console.log("Respuesta",data);
  } catch (error) {
    console.error(error);
  }
};